import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MP',
  engine: 'createJS',
  gameConfig: dataConfig,
  title: [
    {
      text: 'Wskaż na ilustracji urządzenia umieszczone w ramce. W tym celu klikaj kolejno w każde z nich. Czy znasz nazwy tych urządzeń?',
      audio: 'games/page002_game3/audio/z2c3.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page002_game3/audio/z2c3brawo.mp3',
    // negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
